/** @jsx h */
/* eslint-disable */

import { h, Component } from 'preact';
import { PropTypes } from 'preact-compat';
import { Router, route } from 'preact-router';
import uuidv4 from 'uuid/v4';
import Prismic from 'prismic-javascript';
import { bindActionCreators } from 'redux';
import { connect } from 'preact-redux';
import ReactGA from 'react-ga';
// DON'T TOUCH IT!!!!! IF YOU REMOVE IT, CALLS WON'T WORK AT ALL!!!! DONT'T TOUCH ADAPTER
import adapter from 'webrtc-adapter';

import Push from 'push.js';
import ReactNotification, { store } from 'react-notifications-component';
import EventEmitter from 'eventemitter3';

import { LogLevel } from '@bugfender/sdk';
import * as Logger from '../utils/logger';
import {
  safeDisableMultimediaKeys,
  safeEnableMulimediaKeys,
  safeSetMediaPlaybackState,
  createInvisibleAudioElementFromMedia
} from '../utils/media-session'

import Header from './global/header';
import Footer from './global/footer';
import Communication from './communication/communication-component';
import Notification from './communication/notification';
import APINotification, { API_NOTIFICATION_TYPE } from './api-notifications';
import DeviceActivity from './global/device-activity';

import Home from '../routes/home';
import User from '../routes/user';
import Preview from '../routes/preview';
import StaticPage from '../routes/static-page';
import LogIn from '../routes/log-in';
import SignUp from '../routes/sign-up';
import LogInOrSignup from '../routes/login-or-signup';
import ActivityClient from '../routes/activity';
import ActivityPros from '../routes/activity/pros';
import EditProfile from '../routes/edit-profile';
import AllTransactions from '../routes/transactions';
import ForgotPassword from '../routes/forgot-password';
import SettingsPage from '../routes/settings';
import SelectInterest from '../routes/select-interest';
import RegisterPro from '../routes/register-pro';
import ContactRoute from '../routes/contact-us';
import ErrorRoute from '../routes/errorRoute';
import FAQ from '../routes/faq';
import BlogPage from '../routes/blog';
import LanguagePractice from '../routes/language-practice';
import ImmigrationLaw from '../routes/immigration-law';
import LanguageLearners from '../routes/language-learners';
import FeaturedService from '../routes/featured-service';
import AccountActivationSuccess from '../routes/accountActivationSuccess';
import AccountActivationError from '../routes/accountActivationError';
import Api from '../routes/api';
import UnsupportedBrowsers from '../components/unsupported-browsers/';
import UpcomingBookings from '../routes/upcoming-bookings';
// import FeaturedService from '../routes/featured-service';

import PrismicConfig from '../prismic/prismic-configuration';
import { uids, types, tags } from '../prismic/uids';
import {
  RU, EN, IT, ES, PL, AE, PT, DE, FR, langs, statuses, USER_AUTH, LOCAL_STORAGE, BRANCH_IO_REF_TYPES, EVENT_BUS_EVENTS,
} from '../utils/consts';
import Connection, { 
  CALL_FAILED_EVENT,
  CALL_FINISHED_EVENT,
  INCOMING_CALL_REQUEST_EVENT,
  OUTGOING_CALL_STARTED_EVENT,
  CALL_CONNECTED_EVENT,
  SCREEN_SHARING_PERMISSION_DENIED_EVENT,
} from '../utils/connection';
import {
  setMessages, setUser, setMessageHistory, clearUserChat, isCurrentUserRoute,
} from '../utils/con-helpers';

import {
  setUserState,
  removeUserState,
} from '../api/users';

import {
  openComModal,
  closeComModal,
  changeUnreadNum,
  chooseChatPerson,
  clearChats,
  getCallInfo,
  caleeIsBusy,
  processCall,
  speaking,
  changeChat,
  changeConnectionStatus,
  changeVideoStatus,
  setTimeOffset,
  changeReconnectionStatus,
} from '../actions/chat';
import { getCalls } from '../actions/calls';
import { changeUrl } from '../actions/url';
import {
  setBranchIoData, updateUserSettings, getUserByRef, getUnreadMessages, updateBadges, logOff,
} from '../actions/user';
import { resetCallTimer, tickCallTimer, setCallStartTimestamp }  from '../actions/callTimer';

import 'animate.css';
import 'react-notifications-component/dist/theme.css';
import { queryToParams } from '../utils/index';
import { addNotification, removeNotification } from '../actions/api-notifications';
import { applicationCheckOS, applicationInitialise, checkVersionSupport } from '../actions/application';
import { tokenValidate } from '../actions/tokenValidation';
import { langPack } from '../utils/langPack';
import { signInFetchUserData, signInSetProcessed } from '../actions/sign-in';
import FindPro from '../routes/find-pro';
import { selectApplicationCallTimeBeep, selectApplicationIsWebview } from '../reducers/application';
import { forgotPasswordSetResettingMode } from '../actions/forgotPassword';

const { detect } = require('detect-browser');

const __FILE__ = 'app.js';

export const routes = {
  HOME: '/',
  FIND_PRO: '/find-pro',
  SEARCH: '/search',
  // SEARCH_FOR_COMP: '/search/',
  USER: '/user/:userId',
  PREVIEW: '/preview',
  USER_FOR_COMP: '/user/',
  CLIENT: '/client/:userId',
  CLIENT_FOR_COMP: '/client/',
  FAQ: '/help',
  FAQ_LINK: '/#faq',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  CONTACT_US: '/contact-us',
  CONTACT_US_LINK: '/#contact-us',
  HOW_WORKS_LINK: '/#how-it-works',
  BECOME_PRO_LINK: '/#become-pro',
  SIGN_UP: '/sign-up',
  LOG_IN: '/log-in',
  MY_PROS: '/my-pros',
  MY_BOOKINGS: '/my-bookings',
  MY_CLIENTS: '/my-clients',
  TRANSACTIONS: '/transactions',
  EDIT_PROFILE: '/edit-profile',
  LOGIN_OR_SIGNUP: '/login-or-signup',
  FORGOT_PASSWORD: '/forgot-password',
  SETTINGS: '/settings',
  REGISTER_PRO: '/register-pro',
  BLOG_LINK: '/#blog',
  BLOG_POST: '/blog/:uid',
  LANGUAGE_PRACTICE: '/language-practice',
  IMMIGRATION_ADVICE: '/immigration-advice',
  IMMIGRATION_CONSULTANT: '/immigration-pro',
  LANGUAGE_LEARNERS: '/language-learners',
  FEATURED_SERVICE: '/featured-service/:serviceId',
  FEATURED_SERVICE_FOR_COMP: '/featured-service',
  SELECT_INTEREST: '/select-interest',
  ACCOUNT_ACTIVATION_SUCCESS: '/account-activation-success',
  ACCOUNT_ACTIVATION_ERROR: '/account-activation-error',
  PROFILE: '/profile/:refId',
  PROFILE_FOR_COMP: '/profile/',
  API: '/token',
  CANCELLATION: '/cancellation'
};

export const langRoutes = (lang, route) => (lang == langs[EN].code ? route : `/${lang}${route}`);

const HIDE_NOTIFICATION_TIME = 40000;
const VERSION_CHECK_FREQUENCY = 60000;
let checkVersionSupportTimer = null;

const BRANCH_IO_RETRIES = 4;

class App extends Component {
  constructor(props, context) {
    super(props);

    const uuid = uuidv4();
    const params = queryToParams(window.location.search.replace('?', ''));

    if (params.payment_intent) {
      window.top.postMessage({ message: '3DS-authentication-complete', params }, window.location.origin);
    }

    const audioInput = new Audio();
    audioInput.id = 'webRTCIncomingAudio';
    audioInput.muted = false;
    audioInput.controls = false;

    this.state = {
      prismicCtx: null,
      currentUrl: '',

      chats: {},
      received: -1,
      users: {},
      isConnected: false,
      showNotif: false,
      userVideoStream: false,
      sessionId: uuid,
      avtimeNotificationAudio: createInvisibleAudioElementFromMedia('/assets/AvtimeNotification.mp3', 'avtimeNotification'),
      preBookingNotificationAudio: createInvisibleAudioElementFromMedia('/assets/preBooking.mp3', 'prebookingNotification'),
      bookingEndedNotificationAudio: createInvisibleAudioElementFromMedia('/assets/bookingEnded.mp3', 'bookingEndedNotification'),
      callRingtone: createInvisibleAudioElementFromMedia('/assets/call_ringtone.mp3', 'callRingtone'),
      messageAudio: createInvisibleAudioElementFromMedia('/assets/definite.mp3', 'incomingMessageNotification'),
      reconnectingAudio: createInvisibleAudioElementFromMedia('/assets/reconnecting.mp3', 'reconnectingNotification'),
    };

    this.isFullySupportedEnvironment = context.isSupportedBrowser || context.isSupportedOS;

    if (!this.isFullySupportedEnvironment) {
      // Prevent further initialization as only static routes will be allowed in unsupported browsers
      return;
    }

    Push.Permission.request();

    this.eventBus = new EventEmitter();

    const browser = detect()
    this.preferredOutputDeviceId = browser.name === 'chrome' && browser.os.startsWith('Windows') ? 'communications' : 'default';

    this.connection = new Connection({
      setMsg: this.setMsg.bind(this),
      setMsgHistory: this.setMsgHistory.bind(this),
      setUsr: this.setUsr,
      changeUnreadNum: (...args) => {
        if (this.state.currentUrl === routes.MY_CLIENTS) {
          this.props.getCalls(true, 1, false);
        } else if (this.state.currentUrl === routes.MY_PROS) {
          this.props.getCalls(false, 1, false);
        }
        this.props.changeUnreadNum(...args);
      },
      changeConnectedState: (isConnected) => this.setState({ isConnected }),
      getCInfo: () => this.props.communicateModal.callInfo,
      getCallInfo: this.props.getCallInfo,
      openComModal: this.props.openComModal,
      closeComModal: this.closeComModal,
      createNotification: this.createNotification,
      chooseChatPerson: this.chooseChatPerson,
      changeCallRingtoneStatus: this.changeCallRingtoneStatus,
      caleeIsBusy: this.props.caleeIsBusy,
      processCall: this.props.processCall,
      speaking: this.props.speaking,
      setAutoFinishNotif: this.setAutoFinishNotif,
      setAutoFinishPreBookingNotif: this.setAutoFinishPreBookingNotif,
      setAutoFinishBookingEndedNotif: this.setAutoFinishBookingEndedNotif,
      undoAutoFinishNotif: this.undoAutoFinishNotif,
      changeVideoStreamStatus: this.changeUserVideoStreamStatus,
      uuid: this.state.sessionId,
      updateMsgStatus: this.updateMsgStatus.bind(this),
      setTimeOffset: this.setTimeOffset,
      messageAudio: this.state.messageAudio,
      reconnect: this.reconnect,
      changeReconnectionStatus: this.handleReconnectionStatusChange,
      audioInput,
    });
    this.sendPresenceThunk = this.connection.sendPresence.bind(this.connection);
  }

  componentDidMount() {
    const {
      applicationCheckOS: onApplicationCheckOS,
      initialise,
      fetchUserData,
      setProcessed,
      checkApplicationVersionSupport,
    } = this.props;

    const { reconnectingAudio } = this.state;

    onApplicationCheckOS();

    if (!this.isFullySupportedEnvironment) {
      return;
    }

    initialise();

    checkVersionSupportTimer = setInterval(checkApplicationVersionSupport, VERSION_CHECK_FREQUENCY);

    this.eventBus.on(EVENT_BUS_EVENTS.PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);

    const deviceId = localStorage.getItem('uuid');

    if (!deviceId) {
      localStorage.setItem('uuid', uuidv4());
    }

    firebase.analytics().logEvent('Launch_the_App');

    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }

    reconnectingAudio.addEventListener('ended', () => {
      reconnectingAudio.currentTime = 0;
      reconnectingAudio.play().catch(() => {
        console.error('Cannot play reconnection audio');
        safeSetMediaPlaybackState('none')
      });
      safeSetMediaPlaybackState('none')
    });

    this.state.callRingtone.addEventListener('ended', () => {
      this.state.callRingtone.currentTime = 0;
      this.state.callRingtone.play();
      safeSetMediaPlaybackState('none')
    });

    document.body.addEventListener('click', this.setUpAudio);
    document.body.addEventListener('keydown', this.setUpAudio);
    window.addEventListener('storage', this.updatedUserAuth);
    window.addEventListener('pagehide', this.onPageHide);

    this.connection.events.on(CALL_FAILED_EVENT, this.onCallFailed, this);
    this.connection.events.on(INCOMING_CALL_REQUEST_EVENT, this.onCallStarted, this);
    this.connection.events.on(OUTGOING_CALL_STARTED_EVENT, this.onCallStarted, this);
    this.connection.events.on(CALL_FINISHED_EVENT, this.onCallFinished, this);
    this.connection.events.on(CALL_CONNECTED_EVENT, this.onCallConnected, this);
    this.connection.events.on(SCREEN_SHARING_PERMISSION_DENIED_EVENT, this.onScreenSharingPermissionDenied, this);

    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        const getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        return (getUserMedia)
          ? new Promise(((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject);
          }))
          : Promise.reject(new Error('getUserMedia is not implemented in this browser'));
      };
    }

    this._disableMultimediaKeys();

    navigator.mediaDevices
    && typeof navigator.mediaDevices.addEventListener === 'function'
    && navigator.mediaDevices.addEventListener('devicechange', this.onMediaDevicesChanged);

    if (this.props.userData.id) {
      this.reconnect(uuidv4());
    }

    const userAuth = localStorage.getItem(USER_AUTH);

    if (userAuth) {
      fetchUserData(`Bearer ${userAuth}`);
    } else {
      setProcessed();
    }

    this.initBranchIo();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.isFullySupportedEnvironment) {
      return;
    }

    const { userData: prevUser = {} } = this.props;
    const { userData: { loading, id } } = nextProps;
    if (!prevUser.id && nextProps.userData.id) {
      this.reconnect(uuidv4());
      this.props.getUnreadMessages();

      if (this.props.redirect.refId) {
        this.props.getUserByRef(this.props.redirect.refId);
      }
    }
    if (!loading && prevUser.loading && !id) {
      const { name } = nextProps.branchIo;
      if (name === 'registration') {
        route(routes.SIGN_UP);
      }
      if (name === 'profile') {
        route(`${routes.PROFILE_FOR_COMP}${nextProps.branchIo.value}`);
      }
    }
    if ((nextProps.branchIo.name && !prevUser.id && nextProps.userData.id)
      || (nextProps.userData.id && nextProps.branchIo.name && nextProps.branchIo !== this.props.branchIo)
      || ((nextProps.userFromDeepLink.id && nextProps.userData.id) || (prevUser.id && nextProps.userFromDeepLink.id))
    ) {
      if (nextProps.branchIo.name === 'sector') {
        this.props.updateUserSettings({ interestSector: [nextProps.branchIo.value] });
        route(routes.FIND_PRO);
        nextProps.setBranchIoData({});
      }
      if (nextProps.branchIo.name === 'profile' && (nextProps.userFromDeepLink.id || this.props.userFromDeepLink.id)) {
        route(`${routes.USER_FOR_COMP}${nextProps.userFromDeepLink.id}`);
        nextProps.setBranchIoData({});
      }
    }
    if (prevUser.id && !nextProps.userData.id) {
      this.connection.disconnect();
      this.setState({ chats: {}, users: {} });
      this.props.clearChats();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isWebview,
      callTimeBeep,
      locale,
      addNotification: onAddNotification,
      application: { isUnsupportedMobileOs },
      userData: { id, settings },
    } = this.props;

    if (isUnsupportedMobileOs && !isWebview && !prevProps.application.isUnsupportedMobileOs) {
      setTimeout(() => {
        onAddNotification({
          reloadRequired: false,
          id: uuidv4(),
          message: langPack[locale].NOTIFICATIONS.DOWNLOAD_TO_USE_ON_MOBILE,
          type: API_NOTIFICATION_TYPE.SUCCESS,
        })
      }, 1000);
    }

    if (!this.isFullySupportedEnvironment) {
      return;
    }

    if (prevProps.callTimeBeep !== callTimeBeep) {
      this.connection.setCallTimeBeep(callTimeBeep);
    }

    if (prevState.chats !== this.state.chats) {
      this.props.changeChat(this.state.chats);
    }
    if (this.state.isConnected !== prevState.isConnected) {
      this.props.changeConnectionStatus(this.state.isConnected);
    }

    if (id && (!settings || !settings.interestSector.length && this.state.currentUrl !== routes.SELECT_INTEREST)) {
      route(routes.SELECT_INTEREST);
    }

    if (this.props.notifications && this.props.notifications !== prevProps.notifications && this.props.notifications.length) {
      const newNotifications = this.props.notifications || [];
      const uniqueNotifications = this.uniqueNotifications(prevProps.notifications, newNotifications);

      uniqueNotifications.forEach(notification => {
        this.handleAddNotification(notification);
      });
    }
  }

  componentWillMount() {
    ReactGA.initialize('UA-127710081-1');
    this.buildContext().then((prismicCtx) => {
      this.setState({ prismicCtx });
    }).catch((e) => {
      console.error(`Cannot contact the API, check your prismic configuration:\n${e}`);
    });
  }

  /**
   *
   * @param {boolean} isReconnect
   */
  handleReconnectionStatusChange = (isReconnect) => {
    const { changeReconnectionStatus } = this.props;

    this.changeReconnectionAudioStatus(isReconnect);
    changeReconnectionStatus(isReconnect);
  }

  initBranchIo = () => {
    this.remainingBranchIORetries = BRANCH_IO_RETRIES;

    branch.init(
      process.env.PREACT_APP_BRANCH_IO_KEY,
      { retries: BRANCH_IO_RETRIES },
      this.getBranchIoData);
  };

  setUpAudio = () => {
    /*
    * Permissions to play audio in Safari
    * */

    document.body.removeEventListener('click', this.setUpAudio);
    document.body.removeEventListener('keydown', this.setUpAudio);

    safeSetMediaPlaybackState('none')
  }

  changeCallRingtoneStatus = (play = true) => {
    if (play) {
      this.safeSetSinkId(this.state.callRingtone, this.preferredOutputDeviceId);
      this.state.callRingtone.muted = false;
      this.state.callRingtone.play();
      safeSetMediaPlaybackState('none')
    } else {
      this.state.callRingtone.pause();
      this.state.callRingtone.muted = true;
      this.state.callRingtone.currentTime = 0;
      safeSetMediaPlaybackState('none')
    }
  }

  changeReconnectionAudioStatus = (play) => {
    const { reconnectingAudio } = this.state;

    if (play) {
      this.safeSetSinkId(this.state.reconnectingAudio, this.preferredOutputDeviceId);
      reconnectingAudio.muted = false;
      reconnectingAudio.play().catch(() => {
        console.error('Cannot play reconnection audio');
        safeSetMediaPlaybackState('none')
      });
      safeSetMediaPlaybackState('none')
    } else {
      reconnectingAudio.pause();
      reconnectingAudio.muted = true;
      reconnectingAudio.currentTime = 0;
      safeSetMediaPlaybackState('none')
    }
  }

  initConnection = () => {
    this.connection.initializeConnection({
      ...this.props,
      uuid: this.state.uuid,
    }).catch((error) => {
      console.error('Cannot initialise connection');

      throw error;
    });
  }

  reconnect = (uuid = uuidv4()) => {
    this.setState({
      uuid,
    }, () => this.initConnection());
  }

  _disableMultimediaKeys = () => {
    safeDisableMultimediaKeys()
  }

  _enableMultimediaKeys = () => {
    safeEnableMulimediaKeys()
  }
  
  onCallFailed = (amICallee, reason) => {
    window.removeEventListener('beforeunload', this.onPageUnloadWhileCallIsInProgress, { capture: true });
    clearInterval(this.callSecondsInterval);
    this.callSecondsInterval = null;
    setTimeout(() => {
      this.createNotification(`Failed to ${amICallee ? 'accept' : 'initiate'} the call`, reason, 10000)
    }, 500);
  }

  onCallStarted = () => {
    this.props.resetCallTimer();
    window.addEventListener('beforeunload', this.onPageUnloadWhileCallIsInProgress, { capture: true });
  }

  onCallFinished = () => {
    window.removeEventListener('beforeunload', this.onPageUnloadWhileCallIsInProgress, { capture: true });
    clearInterval(this.callSecondsInterval);
    this.callSecondsInterval = null;
  }

  onCallConnected = () => {
    this.props.setCallStartTimestamp();
    this.callSecondsInterval = setInterval(
      () => this.props.tickCallTimer(),
      1000,
    );
  }

  onPageUnloadWhileCallIsInProgress = (event) => {
    event.preventDefault();
    return event.returnValue = "A call is in progress. Are you sure you want to close the page and finish the call?";
  }

  onScreenSharingPermissionDenied = (reason) => {
    setTimeout(() => {
      this.createNotification('Could not share the screen content', reason);
    }, 100);
  }

  getBranchIoData = (err, data) => {
    const __METHOD__ = 'getBranchIoData';

    const {
      getUserByRef: onGetUserByRef,
      setBranchIoData: onSetBranchIoData,
      setPasswordResettingMode,
      tokenValidate: onTokenValidate,
      userData: { loading, id },
      addNotification: onAddNotification
    } = this.props;

    if (err) {
      Logger.logWithTag(
        __FILE__,
        __METHOD__,
        Logger.TAG_BRANCH_IO,
        'Failed to parse branch link data',
        LogLevel.Error,
        err.message,
        false,
      );

      if (this.remainingBranchIORetries === BRANCH_IO_RETRIES) {
        setTimeout(() => onAddNotification({
          reloadRequired: false,
          id: uuidv4(),
          message: [
            <p>You've come to this page by clicking a link.</p>,
            <p>We are having trouble determining its final destination. Please, wait a moment, we will retry a couple of times.</p>,
          ],
          type: API_NOTIFICATION_TYPE.WARNING,
          dismissAfter: 10000,
        }), 0);
      }

      this.remainingBranchIORetries = this.remainingBranchIORetries - 1;

      if (this.remainingBranchIORetries === 0) {
        setTimeout(() => onAddNotification({
          reloadRequired: false,
          id: uuidv4(),
          message: [
            <p>We have made several attempts to determine the final destination for the link you have clicked, but all of them failed.</p>,
            <p>Please, try again in 10 minutes or contact Telmie Support.</p>,
          ],
          type: API_NOTIFICATION_TYPE.DANGER,
          dismissAfter: 10000,
        }), 0);
      }

      return;
    };

    this.remainingBranchIORetries = BRANCH_IO_RETRIES;

    /**
     * @type {{
     *  data_parsed: {
     *    schooseChatPersonectorTag,
     *    ref_id: string,
     *    ref_type: string,
     *    partner_tag
     * } }}
     */
    const { data_parsed: dataParsed } = data;

    (Object.keys(dataParsed).length > 0) && dataParsed["+clicked_branch_link"] && Logger.logWithTag(
      __FILE__,
      __METHOD__,
      Logger.TAG_BRANCH_IO,
      'A branch.io link has been successfully parsed',
      LogLevel.Info,
      dataParsed,
      true,
    )

    let branchIoData;

    if (dataParsed.ref_type === BRANCH_IO_REF_TYPES.RESET_PASSWORD) {
      const { email, token } = dataParsed;

      branchIoData = { email, token };

      setPasswordResettingMode(branchIoData);

      return;
    }

    if (dataParsed.ref_type === 'REGISTRATION') {
      branchIoData = { name: 'registration', value: dataParsed.email };

      const { token } = dataParsed;

      onTokenValidate({ token });

      onSetBranchIoData(branchIoData);
    }
    if (dataParsed.ref_type === 'PARTNER') {
      branchIoData = { name: 'partner', value: dataParsed.partner_tag };
      onSetBranchIoData(branchIoData);
    }
    if (dataParsed.schooseChatPersonectorTag) {
      branchIoData = { name: 'sector', value: dataParsed.sectorTag };
    } else if (dataParsed.ref_id) {
      branchIoData = { name: 'profile', value: dataParsed.ref_id };
      onGetUserByRef(branchIoData.value);
    }
    if (branchIoData) {
      if (!loading && !id) {
        if (branchIoData.name === 'profile') {
          route(`${routes.PROFILE_FOR_COMP}${branchIoData.value}`);
        } else if (dataParsed.ref_type !== 'REGISTRATION') {
          route(routes.SIGN_UP);
          onSetBranchIoData(branchIoData);
        }
      } else {
        onSetBranchIoData(branchIoData);
      }
    }
  };

  createNotification = (title = '', body = '', timeout = 10000, callback = () => {
  }) => {
    const __METHOD__ = 'App::createNotification'

    Push.create(title, {
      body,
      icon: '/assets/icons/favicon-16x16.png',
      timeout,
      onClick() {
        window.focus();
        callback();
        this.close();
      },
    }).catch((err) => {
      Logger.logWithTag(__FILE__, __METHOD__, Logger.TAG_UI, `Failed to create a UI notification: ${err}`, err)
    });
  }

  setMsg = (userId, isPro, id, msg, isMy = false) => {
    const isCurrentFeaturedService = this.props.communicateModal.person && this.props.communicateModal.person.id === userId;
    if (isCurrentFeaturedService || isCurrentUserRoute(this.state.currentUrl, userId)) {
      this.setState((prev) => setMessages(id, msg, isMy, prev));
    }
  }

  setMsgHistory = (id, msgArr, count) => this.setState((prev) => setMessageHistory(id, msgArr, count, prev));

  setUsr = (user) => {
    !isCurrentUserRoute(this.state.currentUrl, user.id, user.isUserPro)
    && this.setState((prev) => setUser(user, prev));
  };

  clearChat = (userId) => this.setState((prev) => clearUserChat(userId, prev));

  setDisplayedStatus = (userJID) => this.setState((prev) => ({
    chats: {
      ...prev.chats,
      [userJID]: {
        ...prev.chats[userJID],
        isDisplayed: true,
        mesId: '',
        thread: '',
      },
    },
  }));

  onPresenceAvailable = () => {
    this.props.getUnreadMessages();
  }

  closeComModal = () => {
    this.props.changeVideoStatus(false);
    this.setState({ userVideoStream: false });
    this.props.closeComModal();
  }

  setTimeOffset = (offset) => {
    this.props.setTimeOffset(offset);
  }

  updateMsgStatus = (chatId, messId, status) => {
    this.setState(({ chats }) => {
      const currentChat = chats[chatId];
      if (currentChat) {
        const { lastMessage } = currentChat;
        let messageIndex = 0;
        if (status === statuses.READ) {
          if (lastMessage === messId) {
            messageIndex = currentChat.chat.length - 1;
          } else {
            messageIndex = currentChat.chat.findIndex((item) => item.id === messId);
          }
        }
        const newChat = currentChat.chat.map((item, index) => {
          let msg;
          if (index <= messageIndex && (item.status !== statuses.READ && item.status !== statuses.FAILED)) {
            msg = {
              ...item,
              status,
            };
          } else if (item.id === messId) {
            msg = {
              ...item,
              status,
            };
          } else {
            msg = item;
          }
          return msg;
        });
        return {
          chats: {
            ...chats,
            [chatId]: {
              ...chats[chatId],
              chat: newChat,
            },
          },
        };
      }
    });
  };

  changeUserVideoStreamStatus = (status) => {
    this.props.changeVideoStatus(status);
    this.setState({ userVideoStream: status });
  }

  chooseChatPerson = (person, witRedirect = true) => {
    this.props.updateBadges(person);
    this.props.chooseChatPerson(person);
    witRedirect && route(`${routes.USER_FOR_COMP + person.toUser.id}#chat`);
  }

  hideNotif = () => {
    this.setState({ showNotif: false });
    clearTimeout(this.hideNotifTimeout);
    this.hideNotifTimeout = null;
  };

  setAutoFinishNotif = () => {
    this.hideNotifTimeout = setTimeout(this.hideNotif, HIDE_NOTIFICATION_TIME);
    this.safeSetSinkId(this.state.avtimeNotificationAudio, this.preferredOutputDeviceId);
    this.state.avtimeNotificationAudio.play();
    safeSetMediaPlaybackState('none')
    this.setState({ showNotif: true });
  }

  setAutoFinishPreBookingNotif = () => {
    this.hideNotifTimeout = setTimeout(this.hideNotif, HIDE_NOTIFICATION_TIME);
    this.safeSetSinkId(this.state.preBookingNotificationAudio, this.preferredOutputDeviceId);
    this.state.preBookingNotificationAudio.play();
    safeSetMediaPlaybackState('none')
    this.setState({ showNotif: true });
  }

  setAutoFinishBookingEndedNotif = () => {
    this.hideNotifTimeout = setTimeout(this.hideNotif, HIDE_NOTIFICATION_TIME);
    this.safeSetSinkId(this.state.bookingEndedNotificationAudio, this.preferredOutputDeviceId);
    this.state.bookingEndedNotificationAudio.play();
    safeSetMediaPlaybackState('none')
    this.setState({ showNotif: true });
  }

  undoAutoFinishNotif = () => {
    clearTimeout(this.hideNotifTimeout);
    this.hideNotifTimeout = null;
  }

  handleRoute = (e) => {
    // this.updatedUserAuth();
    e.previous && this.handleClearNotifications();
    ReactGA.pageview(e.url);
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
    this.setState({ currentUrl: e.url });
    this.props.changeUrl(e.url);
  };

  buildContext() {
    const { accessToken } = PrismicConfig;
    return Prismic.api(PrismicConfig.apiEndpoint, { accessToken }).then((api) => ({
      api,
      endpoint: PrismicConfig.apiEndpoint,
      accessToken,
      linkResolver: PrismicConfig.linkResolver,
    }));
  }

  renderProRoutes = () => this.isFullySupportedEnvironment ? [
    ...this.renderUserRoutes(),
    <ActivityClient path={routes.MY_CLIENTS} isProCalls eventBus={this.eventBus} />,
    <User
      path={routes.CLIENT}
      isPro={false}
      users={this.state.users}
      clearChat={this.clearChat}
      setDisplayedStatus={this.setDisplayedStatus}
      received={this.state.received}
      chooseChatPerson={this.chooseChatPerson}
      uuid={this.state.sessionId}
      connection={this.connection}
      eventBus={this.eventBus}
    />,
    <Preview
      path={routes.PREVIEW}
      clearChat={this.clearChat}
    />,
  ] : [
    <UnsupportedBrowsers path={routes.MY_CLIENTS} />,
    <UnsupportedBrowsers path={routes.CLIENT} />,
    <UnsupportedBrowsers path={routes.PREVIEW} />,
  ];

  renderUserRoutes = () => this.isFullySupportedEnvironment ? [
    ...this.renderDefaultRoutes(),
    <FindPro path={routes.FIND_PRO} />,
    <ActivityPros path={routes.MY_PROS} isProCalls={false} eventBus={this.eventBus} />,
    <UpcomingBookings path={routes.MY_BOOKINGS} />,
    <AllTransactions path={routes.TRANSACTIONS} />,
    <User
      path={routes.USER}
      users={this.state.users}
      clearChat={this.clearChat}
      setDisplayedStatus={this.setDisplayedStatus}
      received={this.state.received}
      chooseChatPerson={this.chooseChatPerson}
      uuid={this.state.sessionId}
      connection={this.connection}
      eventBus={this.eventBus}
    />,
    <EditProfile path={routes.EDIT_PROFILE} />,
    <FeaturedService
      path={routes.FEATURED_SERVICE}
      connection={this.connection}
      chooseChatPerson={this.chooseChatPerson}
      users={this.state.users}
      uuid={this.state.sessionId}
      clearChat={this.clearChat}
      received={this.state.received}
      setDisplayedStatus={this.setDisplayedStatus}
    />,
    <RegisterPro path={routes.REGISTER_PRO} />,
    <SettingsPage
      path={routes.SETTINGS}
      setUserState={setUserState}
      removeUserState={removeUserState}
    />,
    <SelectInterest
      path={routes.SELECT_INTEREST}
    />,
  ] : [
    ...this.renderDefaultRoutes(),
    <UnsupportedBrowsers path={routes.FIND_PRO} />,
    <UnsupportedBrowsers path={routes.MY_PROS} />,
    <UnsupportedBrowsers path={routes.MY_BOOKINGS} />,
    <UnsupportedBrowsers path={routes.TRANSACTIONS} />,
    <UnsupportedBrowsers path={routes.EDIT_PROFILE} />,
    <UnsupportedBrowsers path={routes.FEATURED_SERVICE} />,
    <UnsupportedBrowsers path={routes.REGISTER_PRO} />,
    <UnsupportedBrowsers path={routes.SETTINGS} />,
    <UnsupportedBrowsers path={routes.USER} />,
    <UnsupportedBrowsers path={routes.SELECT_INTEREST} />,
];

  renderDefaultRoutes = () => this.isFullySupportedEnvironment ? [
    ...this.renderLangRoutes(langs[EN].code),
    ...this.renderLangRoutes(langs[RU].code),
    ...this.renderLangRoutes(langs[IT].code),
    ...this.renderLangRoutes(langs[ES].code),
    ...this.renderLangRoutes(langs[PL].code),
    ...this.renderLangRoutes(langs[AE].code),
    ...this.renderLangRoutes(langs[PT].code),
    ...this.renderLangRoutes(langs[DE].code),
    ...this.renderLangRoutes(langs[FR].code),
    <Api path={routes.API} />,
    <LogIn path={routes.LOG_IN} />,
    <SignUp path={routes.SIGN_UP} prismicCtx={this.state.prismicCtx} uid={uids.REGISTRATION} />,
    <LogInOrSignup path={routes.LOGIN_OR_SIGNUP} />,
    <ForgotPassword path={routes.FORGOT_PASSWORD} />,
    <AccountActivationSuccess path={routes.ACCOUNT_ACTIVATION_SUCCESS} prismicCtx={this.state.prismicCtx} />,
    <AccountActivationError path={routes.ACCOUNT_ACTIVATION_ERROR} prismicCtx={this.state.prismicCtx} />,
  ] : [
    ...this.renderLangRoutes(langs[EN].code),
    ...this.renderLangRoutes(langs[RU].code),
    ...this.renderLangRoutes(langs[IT].code),
    ...this.renderLangRoutes(langs[ES].code),
    ...this.renderLangRoutes(langs[PL].code),
    ...this.renderLangRoutes(langs[AE].code),
    ...this.renderLangRoutes(langs[PT].code),
    ...this.renderLangRoutes(langs[DE].code),
    ...this.renderLangRoutes(langs[FR].code),
    <UnsupportedBrowsers path={routes.API} />,
    <UnsupportedBrowsers path={routes.LOG_IN} />,
    <UnsupportedBrowsers path={routes.SIGN_UP} />,
    <UnsupportedBrowsers path={routes.LOGIN_OR_SIGNUP} />,
    <UnsupportedBrowsers path={routes.FORGOT_PASSWORD} />,
    <UnsupportedBrowsers path={routes.ACCOUNT_ACTIVATION_SUCCESS} />,
    <UnsupportedBrowsers path={routes.ACCOUNT_ACTIVATION_ERROR} />,
  ];

  renderLangRoutes = (lang) => (this.isFullySupportedEnvironment ? [
    <Preview
      path={routes.PROFILE}
    />,
    <Home path={langRoutes(lang, routes.HOME)} prismicCtx={this.state.prismicCtx} type={types.HOMEPAGE} />,
    <ImmigrationLaw
      path={langRoutes(lang, routes.IMMIGRATION_CONSULTANT)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.IMMIGRATION_ADVICE}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <ImmigrationLaw
      path={langRoutes(lang, routes.IMMIGRATION_ADVICE)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.IMMIGRATION_CLIENTS}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <LanguagePractice
      path={langRoutes(lang, routes.LANGUAGE_PRACTICE)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.LANGUAGE_PRACTICE}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <LanguageLearners
      path={langRoutes(lang, routes.LANGUAGE_LEARNERS)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.LANGUAGE_LEARNERS}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <BlogPage path={langRoutes(lang, routes.BLOG_POST)} prismicCtx={this.state.prismicCtx} />,
    <FAQ path={langRoutes(lang, routes.FAQ)} prismicCtx={this.state.prismicCtx} type={types.FAQ} />,
    <StaticPage
      path={langRoutes(lang, routes.TERMS)}
      prismicCtx={this.state.prismicCtx}
      type={types.STATIC_PAGE}
      tag={tags.TERMS}
    />,
    <StaticPage
      path={langRoutes(lang, routes.PRIVACY)}
      prismicCtx={this.state.prismicCtx}
      type={types.STATIC_PAGE}
      tag={tags.PRIVACY}
    />,
    <StaticPage
      path={langRoutes(lang, routes.CANCELLATION)}
      prismicCtx={this.state.prismicCtx}
      type={types.STATIC_PAGE}
      tag={tags.CANCELLATION}
    />,
    <ContactRoute path={langRoutes(lang, routes.CONTACT_US)} />,
  ] : [
    <UnsupportedBrowsers path={routes.PROFILE} />,
    <Home path={langRoutes(lang, routes.HOME)} prismicCtx={this.state.prismicCtx} type={types.HOMEPAGE} />,
    <ImmigrationLaw
      path={langRoutes(lang, routes.IMMIGRATION_CONSULTANT)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.IMMIGRATION_ADVICE}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <ImmigrationLaw
      path={langRoutes(lang, routes.IMMIGRATION_ADVICE)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.IMMIGRATION_CLIENTS}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <LanguagePractice
      path={langRoutes(lang, routes.LANGUAGE_PRACTICE)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.LANGUAGE_PRACTICE}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <LanguageLearners
      path={langRoutes(lang, routes.LANGUAGE_LEARNERS)}
      prismicCtx={this.state.prismicCtx}
      type={types.SERVICE_PAGE}
      tag={tags.LANGUAGE_LEARNERS}
      reviewsUid={uids.SHORT_REVIEWS}
    />,
    <BlogPage path={langRoutes(lang, routes.BLOG_POST)} prismicCtx={this.state.prismicCtx} />,
    <FAQ path={langRoutes(lang, routes.FAQ)} prismicCtx={this.state.prismicCtx} type={types.FAQ} />,
    <StaticPage
      path={langRoutes(lang, routes.TERMS)}
      prismicCtx={this.state.prismicCtx}
      type={types.STATIC_PAGE}
      tag={tags.TERMS}
    />,
    <StaticPage
      path={langRoutes(lang, routes.PRIVACY)}
      prismicCtx={this.state.prismicCtx}
      type={types.STATIC_PAGE}
      tag={tags.PRIVACY}
    />, 
    <StaticPage
    path={langRoutes(lang, routes.CANCELLATION)}
    prismicCtx={this.state.prismicCtx}
    type={types.STATIC_PAGE}
    tag={tags.CANCELLATION}
    />,
    <ContactRoute path={langRoutes(lang, routes.CONTACT_US)} />,
]);

  updatedUserAuth = (e) => {
    if (e.key === USER_AUTH) {
      const { userData: user = {}, fetchUserData } = this.props;

      const localStorageUserAuth = localStorage.getItem(USER_AUTH);

      const updatedToken = `Bearer ${localStorageUserAuth}`;

      const userAuth = user.userAuth || '';

      if (userAuth !== updatedToken) {
        if (localStorageUserAuth) {
          fetchUserData(updatedToken);
        } else {
          this.props.logOff();
        }
      }
    }
  };

  handleClearNotifications = () => {
    const notifications = this.props.notifications || [];
    notifications.forEach((notification) => {
      store.removeNotification(notification.id);
      this.props.removeNotification(notification.id);
    });
  };

  uniqueNotifications = (oldNotifications, newNotifications) => {
    return newNotifications.filter(notification => !oldNotifications.includes(notification));
  };

  handleAddNotification = ({
    reloadRequired, iconClassName, id, type, message, dismissAfter
  }) => {
    const { removeNotification: onRemoveNotification } = this.props;

    const locale = this.props.locale || EN;

    store.addNotification({
      id,
      width: 300,
      content: () => (
        <APINotification
          reloadRequired={reloadRequired}
          type={type}
          iconClassName={iconClassName}
          message={message}
          locale={locale}
        />
      ),
      insert: 'top',
      container: 'top-right',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'fadeOut'],
      click: false,
      onRemoval: (id) => {
        if (reloadRequired) {
          window.location.reload();
        }

        onRemoveNotification(id);
      },
      dismiss: !reloadRequired && {
        duration: dismissAfter || 3000,
        pauseOnHover: true,
      },
    });
  };

  safeSetSinkId = (element, deviceId) => element.setSinkId && typeof element.setSinkId === 'function' && element.setSinkId(deviceId);

  onMediaDevicesChanged = () => {
    navigator.mediaDevices && typeof navigator.mediaDevices.enumerateDevices === 'function' && navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        let newPreferredOutputDeviceId = null;

        devices.forEach((device) => {
          if (device.kind === 'audiooutput' && device.deviceId === 'communications') {
            newPreferredOutputDeviceId = device.deviceId;
          } else if (!newPreferredOutputDeviceId && device.kind === 'audiooutput' && device.deviceId === 'default') {
            newPreferredOutputDeviceId = device.deviceId;
          }
        });

        if (!newPreferredOutputDeviceId) {
          const firstAudioOutputDevice = devices.find((device) => device.kind === 'audiooutput');
          if (firstAudioOutputDevice) {
            newPreferredOutputDeviceId = firstAudioOutputDevice.deviceId;
          }
        }

        if (newPreferredOutputDeviceId && newPreferredOutputDeviceId !== this.preferredOutputDeviceId) {
          this.preferredOutputDeviceId = newPreferredOutputDeviceId
        }
      });
  }

  onLogout() {
    this.connection.gracefullyCloseCallOnLogout();
  }

  onPageHide = (_event) => {
    this.connection.gracefullyCloseCallOnLogout();
  }

  render() {
    const {
      userData: user = {}, openComModal,
    } = this.props;
    const locale = this.props.locale || EN;
    const isLoading = user.loading;

      return (
        <div id="app">
          <ReactNotification />
          { 
            this.isFullySupportedEnvironment && <DeviceActivity
              isConnected={this.state.isConnected}
              sendPresence={this.sendPresenceThunk}
              eventBus={this.eventBus}
              callEvents={this.connection.events} /> 
          }
          {
            (this.state.prismicCtx !== null) && ([
            <Header
              locale={locale}
              prismicCtx={this.state.prismicCtx}
              uid={uids[locale].MESSAGE}
              openComModal={openComModal}
              onLogout={this.onLogout.bind(this)}
            />,
            <div className="mainContainer" style={{ minHeight: window.outerHeight - 80 < 755 ? 755 : window.outerHeight - 80 }}>
              <Router onChange={this.handleRoute}>
                {user.id
                  ? (user.pro != null)
                    ? this.renderProRoutes()
                    : this.renderUserRoutes()
                  : this.renderDefaultRoutes()}
                <ErrorRoute
                  isLoading={isLoading}
                  userId={user.id}
                  path={document.location.pathname}
                  locale={this.props.locale}
                  default
                />
              </Router>
              { this.isFullySupportedEnvironment && <Notification isShown={this.state.showNotif} onClick={this.hideNotif} locale={locale} /> }
            </div>,
            <Footer locale={locale} />,
            this.isFullySupportedEnvironment && <Communication
              connection={this.connection}
              isConnected={this.state.isConnected}
              users={this.state.users}
              chooseChatPerson={this.chooseChatPerson}
              user={this.props.userData}
              openComModal={openComModal}
            />])
          }
        </div>
      );
  }

  componentWillUnmount() {
    clearInterval(checkVersionSupportTimer);

    this.connection.events.removeListener(CALL_FAILED_EVENT, this.onCallFailed, this);
    this.connection.events.removeListener(INCOMING_CALL_REQUEST_EVENT, this.onCallStarted, this);
    this.connection.events.removeListener(OUTGOING_CALL_STARTED_EVENT, this.onCallStarted, this);
    this.connection.events.removeListener(CALL_FINISHED_EVENT, this.onCallFinished, this);
    this.connection.events.removeListener(CALL_CONNECTED_EVENT, this.onCallConnected, this);
    this.connection.events.removeListener(SCREEN_SHARING_PERMISSION_DENIED_EVENT, this.onScreenSharingPermissionDenied, this);

    this.eventBus.removeListener(EVENT_BUS_EVENTS.PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
    navigator.mediaDevices
    && typeof navigator.mediaDevices.removeEventListener === 'function'
    && navigator.mediaDevices.removeEventListener('devicechange', this.onMediaDevicesChanged);

    window.removeEventListener('pagehide', this.onPageHide);

    this._enableMultimediaKeys();
  }
}

App.propTypes = {
  isWebview: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  addNotification: PropTypes.func.isRequired,
  application: PropTypes.shape({
    isUnsupportedMobileOs: PropTypes.bool.isRequired,
  }).isRequired,
  applicationCheckOS: PropTypes.func.isRequired,
  fetchUserData: PropTypes.func.isRequired,
  getUserByRef: PropTypes.func.isRequired,
  initialise: PropTypes.func.isRequired,
  setBranchIoData: PropTypes.func.isRequired,
  setPasswordResettingMode: PropTypes.func.isRequired,
  setProcessed: PropTypes.func.isRequired,
  tokenValidate: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
};

App.contextTypes = {
  isSupportedBrowser: PropTypes.bool,
  isSupportedOS: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  application: state.application,
  isWebview: selectApplicationIsWebview(state),
  callTimeBeep: selectApplicationCallTimeBeep(state),
  userData: state.loggedInUser,
  userFromDeepLink: state.userDetails.user,
  locale: state.locale.locale,
  communicateModal: state.communicateModal,
  branchIo: state.branchIo,
  redirect: state.redirect,
  notifications: state.notifications,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addNotification,
  applicationCheckOS,
  initialise: applicationInitialise,
  checkApplicationVersionSupport: checkVersionSupport,
  openComModal,
  closeComModal,
  changeUnreadNum,
  chooseChatPerson,
  clearChats,
  getCallInfo,
  caleeIsBusy,
  processCall,
  speaking,
  changeChat,
  changeConnectionStatus,
  setUserState,
  removeUserState,
  setBranchIoData,
  updateUserSettings,
  changeVideoStatus,
  getCalls,
  changeUrl,
  fetchUserData: signInFetchUserData,
  setPasswordResettingMode: forgotPasswordSetResettingMode,
  setProcessed: signInSetProcessed,
  logOff,
  setTimeOffset,
  getUserByRef,
  getUnreadMessages,
  updateBadges,
  removeNotification,
  tokenValidate,
  changeReconnectionStatus,
  resetCallTimer,
  tickCallTimer,
  setCallStartTimestamp,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./components/app.js